import Image from 'next/image';
import { VFC } from 'react';
import { ThreeDots } from 'react-loader-spinner';

interface Sender {
  name: string;
  imageUrl: string;
}

export interface Props {
  sender: Sender;
}

export const LoadingBubble: VFC<Props> = ({ sender }) => (
  <div className="mx-2 my-4">
    <div className="mb-[-4px] flex items-center">
      {sender.imageUrl && (
        <Image src={sender.imageUrl} width="32" height="32" className="rounded-full" alt="" />
      )}
      <p className="ml-2 inline text-xs">{sender.name}</p>
    </div>
    <div className="my-1 ml-6 flex items-end text-[14px] leading-[22px]">
      <div className="mx-2" style={{ maxWidth: 'max(60%, 18rem' }}>
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <ThreeDots color="#a78bfa" height={20} width={50} />
        </div>
      </div>
    </div>
  </div>
);
